import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const SIDEBAR_EXPANDED_WIDTH = "280px";
const SIDEBAR_COLLAPSED_WIDTH = "88px";

const SidebarCollapseContext = createContext(null);

export function SidebarCollapseProvider({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  const collapseSidebar = useCallback(() => {
    setCollapsed(true);
  }, []);

  useEffect(() => {
    const width = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH;
    document.documentElement.style.setProperty("--app-sidebar-width", width);
    document.documentElement.classList.toggle("sidebar-collapsed", collapsed);

    return () => {
      document.documentElement.classList.remove("sidebar-collapsed");
    };
  }, [collapsed]);

  const value = useMemo(
    () => ({
      collapsed,
      setCollapsed,
      collapseSidebar,
      sidebarWidth: collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH,
    }),
    [collapsed, collapseSidebar]
  );

  return (
    <SidebarCollapseContext.Provider value={value}>
      {children}
    </SidebarCollapseContext.Provider>
  );
}

export function useSidebarCollapse() {
  const ctx = useContext(SidebarCollapseContext);
  if (!ctx) {
    throw new Error(
      "useSidebarCollapse must be used within SidebarCollapseProvider"
    );
  }
  return ctx;
}
